import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { GetOpportunityByID, GetReasonLostOppr, opprDocument } from '../API/API';
import { GetData } from '../API/getApi';
import { selectUser, SetStatusSelected } from '../ReduxStore/userReducer';
import Footer from '../sharedFiles/footer/footer';
import Header from '../sharedFiles/header/header';
import './Followups.css';
import FollowupTable from './FollowupTable';
import { useOutsideAlerter } from "../sharedFiles/dropdownCloser/dropdownCloser";
import CustomButtonModal from "../sharedFiles/CustomButtonModal/CustomButtonModal";

import {
  Box,
  FormControl,
  FormControlLabel, FormLabel,
  InputLabel,
  MenuItem,
  Radio, RadioGroup,
  Select,
  TablePagination,
  TextField
} from '@mui/material';
import ForwardIcon from '@mui/icons-material/Forward';
import { Button } from "react-bootstrap";
import { getDocNumbyOpprId, GetLostDoc, getSQItems } from "../API/OpportunityServices/OpprThunk";
import SunspotLoader from "../sharedFiles/loader/loader";
import { toast, ToastContainer } from "react-toastify";
import { showSubmitConfirmation, showWarningConfirmation } from "../sharedFiles/ConfirmationModel/confirmationModel";
import IconButton from '@mui/material/IconButton';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';  // Import CloseIcon
import CommonDynamicTable from "../sharedFiles/CommonDynamicTable/CommonDynamicTable";
const Opportunity = () => {
  const [tooltip, setTooltip] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const { opprId } = useParams();
  const location = useLocation();
  const { additionalData } = location.state || {};
  const [crmData, setCrmData] = useState({});
  const [stageMaster, setStageMaster] = useState([]);
  const [opprDocNum, setOpprDocNum] = useState("");
  const [prevData, setPrevData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector(selectUser);
  const { GetLostDocData, SQItemsByDocEntry } = useSelector((state) => state.Oppr);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const jwtToken = userData?.JwtToken;
  // const [lostDocValue, setLostDocValue] = useState(false);
  const databaseName = userData?.DatabaseName;
  const SlpCode = userData?.slpCode;
  const accessLevel = userData?.AccessLevel;
  const [opprLostReason, setOpprLostReason] = useState([]);//drop option for lost
  const [selectedDesc, setSelectedDesc] = useState({ id: null, name: '' });
  // const [selectedNum, setSelectedNum] = useState(0);
  const [modelOpen, setModelOpen] = useState(false);
  const [billedDocShow, setBilledDocShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState('Open');//default open
  const [lostRemarks, setLostRemarks] = useState('');
  const [show, setshow] = useState(false);
  const [opporfield, setOpprfield] = useState("");
  const { opprData } = useSelector((state) => state.item);
  const [itemQuantities, setItemQuantities] = useState({
    item1: 0,
    item2: 0,
    item3: 0
  });
  const initialNewStage = {
    id: null,
    openDate: '',
    closingDate: '',
    stage: '',
    percentage: '',
    remarks: '',
    nextStage: '',
    stageId: 0,
    nextStartDate: '',
    nextCloseDate: '',
    nextStage: '',
    nextStageId: 0,
    status: 'O',
    potentialAmount: '',
    comments: '',
  };
  const [newStage, setNewStage] = useState(initialNewStage);
  const [showModal, setShowModal] = useState(false);
  const [isStageSubmitted, setIsStageSubmitted] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [mode, setMode] = useState(false);
  const { listOfOpporID } = useSelector((state) => state.Oppr);


  useEffect(() => {
    fetchData();
    fetchDocument();
    setOpprDocNum("");
    setOpprfield("")
    // dispatch(GetLostDoc({ dbName: databaseName, OpprNo: opprId }))
  }, []);

  const wrapperRef = React.useRef(null);
  useOutsideAlerter(wrapperRef, () => setshow(false));

  const fetchData = async () => {
    try {
      const crmResponse = await GetData(
        `${GetOpportunityByID}${databaseName}&OpprId=${opprId}`,
        {
          headers: {
            wg_token: jwtToken,
          },
        },
        dispatch,
        navigate
      );

      if (crmResponse) {
        const opportunity = crmResponse.opportunities[0];
        setCrmData(opportunity);
        setStageMaster(crmResponse.stages);
        setPrevData(crmResponse.modalFields);
        setOpprLostReason(crmResponse.lostModals)
        const statusMap = { 'O': 'Open', 'L': 'Lost', 'W': 'Won' };
        const status = opportunity.status;

        if (!opportunity.lostReason) {
          setSelectedOption(statusMap[status] || 'Open');
          setSelectedDesc({ id: null, name: '' });
          setLostRemarks("");
        } else {
          setSelectedOption("Lost");
          dispatch(SetStatusSelected(true));
          setSelectedDesc({ id: opportunity.id, name: opportunity.lostReason });
          setOpprfield(opportunity.ledgerChangeDoc);
          // setLostReasonData({ id: opportunity.id, name: opportunity.lostReason });
          setLostRemarks(opportunity.lostRemarks);
        }
      } else {
        setError('No opportunity data available');
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const arstatusValue = opprData && opprData.data?.find(item => item.Opp_No === crmData.opprId)?.AR_Status;

  const fetchDocument = async () => {
    try {
      const OpprResponse = await GetData(
        `${opprDocument}${databaseName}&OpprId=${opprId}`,
        {
          headers: {
            wg_token: jwtToken,
          },
        },
        dispatch,
        navigate
      );

      if (OpprResponse) {
        const item1Quantity = OpprResponse.item1;
        const item2Quantity = OpprResponse.item2;
        const item3Quantity = OpprResponse.item3;

        setItemQuantities({
          item1: item1Quantity,
          item2: item2Quantity,
          item3: item3Quantity,
        });
      } else {
        setError('No data available');
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };



  //handle dropdown change
  const handledropLost = (reason) => {
    setSelectedDesc({ id: reason.id, name: reason.lostReason });
    // setSelectedNum(reason.num);
    setshow(false)
  }
  const handleShow = () => {
    setshow(true);
  }



  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }
  const displayFields = crmData ? Object.entries(crmData) : [];

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleLostRemarks = (event) => {
    setLostRemarks(event.target.value)
  }
  const handleBackNav = () => {
    navigate("/CustomerFollowups"); // Navigate back to the dashboard
  };

  const handleSqHistoryNav = () => {

    navigate("/SqHistory");
  }
  // cusor hover to view hide detail in helper box
  const handleMouseMove = (e) => {
    // Update tooltip position based on mouse position
    setTooltipPosition({
      x: e.clientX - 60,
      y: e.clientY - 100
    });
  };

  const handleMouseEnter = (tooltipText) => {
    setTooltip(tooltipText);
  };

  const handleMouseLeave = () => {
    setTooltip(null);
  };
  const handleReset = () => {
    setSelectedOption("Open");
    setSelectedDesc({ id: null, name: '' });
    setLostRemarks(''); // This will uncheck the radio button
  };


  const handlechangeradio = (event) => {
    setSelectedDesc({ id: null, name: '' })
    setLostRemarks('');
    setOpprfield("");
    dispatch(SetStatusSelected(true));
    const events = event.target.value;
    if (events === "Lost" && itemQuantities.item3.length > 0 && (arstatusValue === "Yes")) {
      toast.warning("The document has been invoiced so 'Lost' status cannot be allow.", {
        position: "bottom-right",
        theme: "dark",
      });
    } else if (events === "Lost" && itemQuantities.item3?.[0]?.docTotal) {
      showWarningConfirmation(() => {
        setSelectedOption(events);
      });
    } else {
      setSelectedOption(events);
    }
  };
  const mergedDocuments = [
    ...(GetLostDocData?.item1 || []),
    ...(GetLostDocData?.item2 || [])
  ];

  const opprStatuses = [{
    // docType: "string",
    // docNum: 0,
    documentsToClose: mergedDocuments,
    // decripId: selectedNum,
    status: selectedOption,
    docNum: opprDocNum?opprDocNum : null ,
    lostRemarks: lostRemarks,
    Descrip: selectedDesc
  }
  ]
  const handlesearchOpprId = (searchId) => {
    if(!searchId){
      setOpprDocNum("");
    }
    setOpprfield(searchId);
    dispatch(getDocNumbyOpprId({ databaseName, SlpCode, accessLevel, searchId }));
  }
  const handlefixOpprId = (Oppr) => {
    setOpprDocNum(Oppr.docNum);
    setOpprfield(Oppr.docNum);
    setBilledDocShow(false);

  }

  const handleApiCall = () => {
    if (crmData?.ledgeChangeDocEntry) {
      dispatch(getSQItems({ databaseName, DocEntry: crmData.ledgeChangeDocEntry }))
    }
    setModelOpen(true);
  }
  const handleCloseModal = () => {
    setModelOpen(false);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <Header />
      <div className="dashBoardMain">
        <div className="dashImage"></div>
        <div className="dashGradient"></div>
        <div className='sqHistorydiv'>
          <div className="TopHisDiv">

            {additionalData !== "SqHistory" ? (
              <div className="d-flex col-4 me-4 me-xl-5 me-xxl-4 col-xl-5 col-xxl-5">
                <button onClick={handleBackNav} className="backIcondiv">
                  <ArrowCircleLeftIcon />
                  <span className='DashBoardName '>Opportunity</span>
                </button>
              </div>
            ) :
              (
                <div className="d-flex col-4 me-4 me-xl-5 me-xxl-4 col-xl-5 col-xxl-5">
                  <button onClick={handleSqHistoryNav} className="backIcondiv">
                    <ArrowCircleLeftIcon />
                    <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">Sales Quatation History</p>
                  </button>
                </div>
              )}
            <div className='opporTitle'>
              <p>Opportunity Details & Stage</p>
            </div>
          </div>

          <div className='StepperGradient3'>
            <div className="fields-container">
              {displayFields.length > 0 ? (
                displayFields.map(([key, value]) => {
                  if (key === "id") return null;
                  {/* {crmData.length > 0 ? (
                crmData.map(([key, value]) => { */}

                  let displayValue;
                  displayValue = value ?? 'N/A';

                  return (
                    <div key={key} className="field-item">
                      <div
                        className="text-label"
                        onMouseMove={handleMouseMove}
                        onMouseEnter={() => handleMouseEnter(displayValue)}
                        onMouseLeave={handleMouseLeave}
                      >
                        <span className="detail">
                          {capitalizeFirstLetter(key.replace(/_/g, ' '))}:
                        </span>
                        <span className="label-hover">
                          {displayValue !== null ? displayValue.toString() : 'N/A'}
                        </span>
                      </div>

                      {/* Tooltip follows cursor */}
                      {tooltip && (
                        <div
                          className="helper-box"
                          style={{
                            left: tooltipPosition.x,
                            top: tooltipPosition.y,
                          }}
                        >
                          {tooltip}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div>No opportunity data available</div>
              )}
            </div>

            {/* {accessLevel && accessLevel === "L1" &&  */}
            <div className="tablehead col-12">
              <div className="btnAddStage col-1">
                <Button
                  variant="success" onClick={() => {
                    setNewStage(initialNewStage);
                    setShowModal(true);
                    setMode(false);
                    setEditMode(false);
                    setIsStageSubmitted(false);
                  }} className="btnadd">
                  Add Stage
                </Button>
              </div>
              <div className='opporStatusBtn col-8'>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <div className="radioGroupContainer">
                    <FormLabel className="boldLabel">Status :</FormLabel>
                    {accessLevel && accessLevel === "L1" ?
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          onChange={handlechangeradio}
                          value={selectedOption}
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          className="radioContainer"
                        >
                          <FormControlLabel value="Open" control={<Radio className="radioButton" />} label="Open" />

                          <FormControlLabel value="Lost" control={<Radio className="radioButton" />} label="Lost" />
                        </RadioGroup>
                      </FormControl> :
                      <div>
                        <FormControl component="fieldset">
                          <RadioGroup
                            row
                            onChange={handlechangeradio}
                            value={selectedOption}
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            className="radioContainer"
                          >
                            <FormControlLabel value="Lost" control={<Radio className="radioButton" />} label="Lost" />
                          </RadioGroup>
                        </FormControl>
                        {crmData?.status !== "L"  &&
                          <button className="resetButton" variant="outlined" onClick={handleReset} >
                            Reset
                          </button>
                        }
                      </div>}
                  </div>
                </Box>

                <div className="statusupadteField">
                  {selectedOption === 'Lost' && (

                    <div className='textfieldreason position-relative'>
                      <TextField
                        id="reasonDropdown"
                        name="reasonDropdown"
                        label="Reason"
                        variant="outlined"
                        className="reasonfield"
                        // autoComplete="off"
                        value={selectedDesc ? selectedDesc.name : ""}
                        onClick={handleShow}
                        disabled={accessLevel === "L2" && crmData.status === "L"}
                      />
                      {show && (
                        <div className="reasondropdown">
                          <ul ref={wrapperRef}>
                            {/* {console.log("opprLostReason", opprLostReason)} */}
                            {opprLostReason.map((reason, index) => (
                              <li
                                className="list"
                                key={index}
                                onClick={() => handledropLost(reason)}>

                                {reason.lostReason}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                  {selectedOption === 'Lost' && (
                    <div className='textfieldRemarks'>
                      <TextField
                        label="Remarks"
                        variant="outlined"
                        size="small"
                        className="remarksfield"
                        onChange={handleLostRemarks}
                        value={lostRemarks}
                        // autoComplete='off'
                        disabled={accessLevel === "L2" && crmData.status === "L"}
                      />
                    </div>

                  )}

                  {selectedOption === 'Lost' && 
                  // selectedDesc?.name === "BILLED OTHER LEDGER"
                    selectedDesc?.name === "BILLED-LEDGER CHANGE"
                   && (
                    <div className='textfieldreason position-relative'>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {/* TextField - your exact disabled logic */}
                        <TextField
                          id="reasonDropdown"
                          name="reasonDropdown"
                          label="Select DocNum"
                          variant="outlined"
                          className="reasonfield"
                          onClick={() => setBilledDocShow(true)}
                          value={opporfield}
                          onChange={(e) => handlesearchOpprId(e.target.value)}
                          disabled={crmData?.status === "L" || (crmData?.status === "O" && crmData?.ledgerChangeDoc && accessLevel === "L2")}

                        />

                        {crmData?.ledgerChangeDoc &&
                          <IconButton
                            onClick={handleApiCall}
                            title="Fetch related documents"
                            size="small"
                            disabled={false} // Always enabled
                          >
                            <ForwardIcon style={{ color: '#182e59', fontSize: '35px' }} />
                          </IconButton>
                        }

                      </div>
                      {/* Your dropdown - unchanged */}
                      {billedDocShow && listOfOpporID && (
                        <ul className="shared-custom-dropdown">
                          {listOfOpporID && listOfOpporID?.length > 0 && listOfOpporID[0]?.docNum ? (
                            listOfOpporID?.map((item, i) => (
                              <li key={i} onClick={() => handlefixOpprId(item)}>
                                {item.opprId} - {item.docNum}
                              </li>
                            ))
                          ) : (
                            <li className="no-options">No results found</li>
                          )}
                        </ul>
                      )}
                    </div>
                  )}

                  {/* <Button className="resetButton" variant="outlined" onClick={handleReset} >
                    Reset
                  </Button> */}
                </div>
              </div>
              <div className="CustomButtonModal col-2 col-md-3">
                {/* Use CustomButtonModal for different buttons */}
                <CustomButtonModal
                  buttonText={`Sq (${itemQuantities.item1.length})`}
                  modalTitle="Sales Quotation"
                  modalContent={itemQuantities.item1}  // Display quantities here

                />

                <CustomButtonModal
                  buttonText={`So (${itemQuantities.item2.length})`}
                  modalTitle="Sales Order"
                  modalContent={itemQuantities.item2}  // Display quantities here

                />

                <CustomButtonModal
                  buttonText={`AR Inv (${itemQuantities.item3.length})`}
                  modalTitle="AR Invoice"
                  modalContent={itemQuantities.item3}  // Display quantities here

                />

              </div>
            </div>
            <FollowupTable
              stageMaster={stageMaster}
              prevdata={prevData}
              fetchData={fetchData}
              OpportunityId={opprId}
              opprStatuses={opprStatuses}
              newStage={newStage}
              setNewStage={setNewStage}
              setShowModal={setShowModal}
              showModal={showModal}
              setMode={setMode}
              mode={mode}
              setLoading={setLoading}
              // isLoading={isLoading}
              handleBackNav={handleBackNav}
              editMode={editMode}
              setEditMode={setEditMode}
              setIsStageSubmitted={setIsStageSubmitted}
              isStageSubmitted={isStageSubmitted}
            // setLostDocValue={setLostDocValue}
            // lostDocValue={lostDocValue}
            />

          </div>
        </div>
        {SQItemsByDocEntry && modelOpen && (
          <Dialog
            open={modelOpen}
            onClose={handleCloseModal}
            maxWidth="lg"
            fullWidth
            
          >
            {/* Dialog Title */}
            <DialogTitle sx={{ position: 'relative' }}>
              <IconButton
                edge="end"
                color="inherit"
                onClick={handleCloseModal}
                sx={{
                  position: 'absolute',
                  top: '8px',
                  right: '12px',
                  color: '#000',
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
               <span>Items</span> 
            </DialogTitle>

            {/* Dialog Content */}
            <DialogContent
              sx={{
                paddingTop: 0,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              {/* ✅ Scrollable Table Area */}
              <Box
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  maxHeight: '55vh', // controls table scroll height
                }}
              >
                <CommonDynamicTable
                  data={SQItemsByDocEntry.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage)}
                    dataType ="LedgerDoc"
                />
              </Box>

              {/* ✅ Fixed Pagination */}
              <TablePagination
                component="div"
                count={SQItemsByDocEntry.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[12, 24, 48]}
              />
            </DialogContent>
          </Dialog>
        )}


      </div>
      {/* <FollowupTable
      SelectedOption={selectedOption}
      SelectedValue={selectedValue}
      /> */}
      <ToastContainer />
      {loading && (
        <div className="loader position-absolute">
          <SunspotLoader />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Opportunity;
